// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"639":"6356676f08bab8d4","642":"3bbeea915dfa9cf1"}[chunkId] + ".js";
};